import firebase from "@firebase/app";
import 'firebase/storage';
const initialState = () =>({
    thisUser: {},
    allUsers:[],
});
const state = initialState();

const getters ={
    thisUser:(state) => state.thisUser,
    allUsers:(state) => state.allUsers,
};

const mutations = {
    thisUser(state,payload){
        state.thisUser = payload;
    },
    clearthisUser(state){
        state.thisUser = {}
    },
    setallUsers(state,payload){
        state.allUsers =payload
    },
    RESET_STATE(state) {
        const newState = initialState();
        Object.keys(newState).forEach(key => {
          state[key] = newState[key];
        });
      },
};

const actions = {
    async getallUsers({ commit }){
        let allUsers = [];
        const db = firebase.firestore();
        const database = await db
        .collection("fb_users");
        // .orderBy("createdAt","desc");   
        database.get().then(function(snapshot) {        
        snapshot.docs.forEach(doc => {             
            const data = doc.data();
            allUsers.push(data)
        })      
        });   
        commit("setallUsers",allUsers);  
    },
};

export default {
    namespace: true,
    state,
    getters,
    actions,
    mutations,
};